<template>
  <v-container fluid grid-list-md>
    <v-layout row wrap justify-center align-center>
      <v-flex xs12 md10>
        <eimza-gate title="Numaralara SMS Gönder">
          <v-alert style="overflow-x: auto;margin: 0 10px;" type="warning">
            <span>
              HATIRLATMA!
              <br>
              Ticari SMS içeriklerinde;
              firmalar için Mersis No, şahıs işletmelerinde ise;
              Ad Soyad ve TC.Kimlik Numarası, telefon veya email gibi iletişim bilgisinin
              RET Hizmeti ile birlikte bulunması önem teşkil etmektedir.
            </span>
          </v-alert>
          <v-card-text>
            <v-form ref="number" lazy-validation>
              <v-layout wrap>
                <v-flex md4 xs12>
                  <button-keys
                    :keys="data.keys"
                    item-value="value"
                    @on:button-key="(val) => { this.msgBox += ` ${val}`; }"
                  ></button-keys>
                  <v-textarea
                    v-model="sendData.numbers"
                    placeholder="Numaralar"
                    :rules="[$rules.empty('Numaralar')]"
                    required
                    clearable
                    rows="25"
                  ></v-textarea>
                </v-flex>
                <v-flex md8 xs12>
                  <v-layout wrap>
                    <v-flex xs12>
                      <senders-or-message-types
                        label="Gönderici Adları"
                        no-data-text="Aktif Gönderici Adı bulunmuyor"
                        :default="senders[0]"
                        :items="data.senders"
                        :rules="[$rules.required({ falseValues: [undefined, null], message: 'Gönderici adı seçimi yapmalısınız' })]"
                        required
                        @on:model-update="(val) => { sendData.sender = val; }"
                      ></senders-or-message-types>
                    </v-flex>
                    <v-flex xs12>
                      <template-selector
                        label="Şablon Seçinizi"
                        :items="data.templates"
                        @on:template-selected="(val) => { msgBox = val.content; }"
                      ></template-selector>
                    </v-flex>
                    <v-flex xs12>
                      <senders-or-message-types
                        label="Tür"
                        required
                        :items="types"
                        :rules="[$rules.required({ falseValues: [undefined, null], message: 'Mesaj türü seçimi yapmalısınız' })]"
                        :default="data.default_message_type"
                        item-text="text"
                        item-value="value"
                        @on:model-update="(val) => { sendData.message_type = val; }"
                      ></senders-or-message-types>
                    </v-flex>
                    <v-flex xs12>
                      <v-layout row>
                        <v-flex xs12>
                          <time-type
                            :rules="[$rules.required({ falseValues: [undefined, null], message: 'Gönderim zamanı seçimi yapmalısınız' })]"
                            @type:update="(val) => (wTimeStat = val)"
                          ></time-type>
                        </v-flex>
                        <v-flex md6 xs12 v-if="wTimeStat">
                          <date-month-picker
                            label="Gönderme Tarihi"
                            :disable-prev="true"
                            :rules="[$rules.required({ falseValues: [''], message: 'Tarih seçimi yapmalısınız' })]"
                            @on:date-selected="(val) => { date = val; dateSelected = true; }"
                          ></date-month-picker>
                        </v-flex>
                        <v-flex md6 xs12 v-if="wTimeStat">
                          <time-picker
                            label="Gönderme Saati"
                            :valid="dateSelected"
                            :rules="[$rules.empty('Gönderme Saati')]"
                            @on:time-selected="(val) => { time = ` ${val}:00`; }"
                          ></time-picker>
                        </v-flex>
                      </v-layout>
                    </v-flex>
                    <v-flex xs12 v-if="$store.state.iys_status === 1">
                      <message-type @type="(val) => (message_content_type = val)"></message-type>
                    </v-flex>
                    <v-flex xs12>
                      <sms-message
                        label="Mesajınız"
                        required
                        :rules="[
                          $rules.empty('Mesaj'),
                          (v) => sendData.message_type === 'turkce' ? v.length <= 877 || 'Maksimum karakter sayısı 882 olabilir.' : sendData.message_type === 'normal' || true,
                        ]"
                        :value="msgBox"
                        :c-message="msgBox"
                        :c-type="sendData.message_type"
                        @text:change="textChange"
                      ></sms-message>
                    </v-flex>
                    <v-flex>
                      <sms-confirmation
                        :context="confirmation.context"
                        :valid="confirmation.valid"
                        @on:disagree="() => { $trigger('setPluginDialog'); confirmation.valid = !confirmation.valid; }"
                        @on:agree="sendMessage"
                      >
                        <template v-slot:activator>
                          <v-btn color="primary" block @click="smsPreview">
                            Mesajı Gönder <v-icon right dark>mdi-send</v-icon>
                          </v-btn>
                        </template>
                      </sms-confirmation>
                    </v-flex>
                  </v-layout>
                </v-flex>
              </v-layout>
            </v-form>
          </v-card-text>
        </eimza-gate>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import { mapActions } from 'vuex';
import { types } from '../../../../misc';
import EimzaGate from '../../../Components/EimzaGate.vue';
import SendersOrMessageTypes from '../../../Components/SMSConstants/SendersOrMessageTypes.vue';
import TemplateSelector from '../../../Components/SMSConstants/TemplateSelector.vue';
import ButtonKeys from '../../../Components/SMSConstants/ButtonKeys.vue';
import SmsMessage from '../../../Components/SMSConstants/SmsMessage.vue';
import DateMonthPicker from '../../../Components/SMSConstants/DateMonthPicker.vue';
import TimePicker from '../../../Components/SMSConstants/TimePicker.vue';
import TimeType from '../../../Components/SMSConstants/TimeType.vue';
import SmsConfirmation from '../../../Components/SMSConfirmation.vue';
import MessageType from '../../../Components/SMSConstants/MessageType.vue';

export default {
  components: {
    EimzaGate,
    SmsConfirmation,
    TimeType,
    TimePicker,
    DateMonthPicker,
    SmsMessage,
    ButtonKeys,
    TemplateSelector,
    SendersOrMessageTypes,
    MessageType,
  },
  name: 'Number',
  data: () => ({
    dateSelected: false,
    wTimeStat: false,
    time: '',
    date: '',
    types,
    data: {},
    sendData: { message_type: null },
    confirmation: { valid: false, context: { examples: [] } },
    selectedTemplate_: {},
    message: '',
    senders: [],
    message_content_type: null,
  }),
  computed: {
    msgBox: {
      get() { return this.message || ''; },
      set(newVal) { this.message = newVal; },
    },
  },
  created() {
    this.send({ route: 'sms/number' }).then((res) => {
      this.data = res.data.data;
      this.senders = res.data.data.senders;
      // eslint-disable-next-line prefer-destructuring
      this.sendData.sender = this.senders[0];
      this.sendData.message_type = this.data.default_message_type;
      const allowedKeys = ['İptal Linki', 'Kısa Kod'];
      this.data.keys = Object.filterByKey(allowedKeys, this.data.keys);
    });
  },
  methods: {
    ...mapActions({ send: 'sendBackend' }),
    sendMessage() {
      const numbers = this.prepareSendData();
      if (this.$refs.number.validate()) {
        this.send({ route: 'sms/number/send', data: this.sendData })
          .then(() => this.resetForm())
          .catch(() => { this.sendData.numbers = numbers; });
      }
    },
    smsPreview() {
      if (this.confirmation.valid) {
        this.confirmation.valid = false;
        this.$trigger('setPluginDialog');
      }
      this.confirmation.valid = this.$refs.number.validate();
      if (this.$refs.number.validate()) {
        this.prepareSendData();
        this.send({ route: 'sms/number/send/preview', data: this.sendData })
          .then((res) => { this.confirmation.context = res.data.data; });
      }
    },
    prepareSendData() {
      const c = this.sendData.numbers;
      let k = this.sendData.numbers;
      // eslint-disable-next-line no-return-assign
      ['.', '\n', '\t', '<br>', '<br/>', '</br>'].map(tok => (k = k.split(tok).join(',')));
      k = k.split(',');
      // eslint-disable-next-line array-callback-return
      k = k.map(val => this.phoneReplace(val.replace(/[^0-9]+/g, '')));
      k = [...new Set(k)].join('\n');
      this.sendData.numbers = k;
      this.sendData.send_time = this.date + this.time;
      this.sendData.message = this.msgBox;
      if (!this.wTimeStat) delete this.sendData.send_time;
      return c;
    },
    phoneReplace(phone) {
      return phone.substr(phone.length - 10);
    },
    // eslint-disable-next-line spaced-comment
    textChange(val/*, messageCount*/) {
      this.msgBox = val;
    },
    resetForm() {
      this.$refs.number.reset();
      this.wTimeStat = false;
    },
  },
};
</script>
